import React from 'react';
import { SignUp } from '@clerk/react';
import { useNavigate } from '../../routes';
import { ROUTES } from '@repo/shared-types/routeRegistry';

/**
 * Clerk SignUp page used after Join the Ecosystem: user creates account with Clerk,
 * then Clerk redirects to COMPLETE_ONBOARDING where we create UserProfile and sync metadata.
 */
export const ClerkSignUpView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-brand-600 rounded-full blur-[100px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-600 rounded-full blur-[100px]" />
      </div>
      <div className="absolute top-6 left-6 right-6 z-20 flex items-center justify-between">
        <button
          type="button"
          onClick={() => navigate(ROUTES.ROOT)}
          className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
        >
          Back
        </button>
      </div>
      <div className="relative z-10">
        <SignUp
          signInUrl={ROUTES.LOGIN}
          fallbackRedirectUrl={ROUTES.COMPLETE_ONBOARDING}
          forceRedirectUrl={ROUTES.COMPLETE_ONBOARDING}
        />
      </div>
    </div>
  );
};

